module.exports = __webpack_public_path__ + "img/1582743530.450e4094.jpg";